import { Modal } from 'components';
import { FC } from 'react';

import { ConfirmUploadContentStyled } from './styles';

interface Props {
  onOk: () => void;
  onCancel: () => void;
  visible: boolean;
}

const ConfirmUpload: FC<Props> = ({ onOk, onCancel, visible }) => (
  <Modal
    visible={visible}
    title="選択した写真をアップロードします"
    okButton={{ text: '確定', onClick: onOk }}
    cancelButton={{
      text: 'キャンセル',
      onClick: onCancel,
    }}
    width={640}
  >
    <ConfirmUploadContentStyled>
      工程内検査写真以外はアップ口ードできません。
      <br />
      この操作は元に戻せません。
    </ConfirmUploadContentStyled>
  </Modal>
);

export default ConfirmUpload;
